import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import colors from 'themes/Main';

const { white, gray01, gradient } = colors;

export const Link = styled(NavLink)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 18px 15px;
  text-decoration: none;
  transition: all 0.3s;

  ${({ hasSubmenu }) =>
    hasSubmenu &&
    `
    &::before {
      content: '';
      right: 0;
      top: 0;
      width: 5px;
      height: 100%;
      background-color: rgba(0,0,0.3);
    `}

  &:hover {
    background: ${gradient};

    svg path {
      fill: ${white};
    }

    p {
      color: ${white};
    }
  }

  svg path {
    fill: ${gray01};
  }
`;

export const LinkText = styled.p`
  font-size: 12px;
  font-weight: 600;
  margin-top: 8px;
  margin-bottom: 0;
  color: ${gray01};
  text-align: center;
`;
